import { SET_EDITCAR } from '../actions';

const caredit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITCAR:
      return [...action.value];  
    default: return state;
  }
}

export default caredit;
